import { Children, PropsWithChildren, useEffect } from 'react'
import { showToast } from 'common/ToastMessage/index'

interface Props {
  dismissDurationInSeconds?: number
}

export const DeclarativeToast = ({ children, dismissDurationInSeconds = 0 }: PropsWithChildren<Props>) => {
  const child = Children.only(children)

  useEffect(() => {
    const dismiss = showToast(child, 0)
    return () => {
      setTimeout(() => {
        dismiss()
      }, dismissDurationInSeconds * 1000)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}
